import { useQuery } from "@tanstack/react-query";
import { DocumentContentLinkService } from "../../../../services/document/document-content-link.service";

export const useDocumentContentLink = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["document-content-link"],
    queryFn: () => DocumentContentLinkService.getListContentLink(),
  });

  return { data, isLoading };
};
